import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { selectIsAdmin } from "../../services/authorization/slices";

export const useCopyOnClick = (value, readOnly) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const isAdmin = useSelector(selectIsAdmin)
  const canRender = isAdmin && readOnly
  const timeoutRef = useRef();

  const handleClick = (e, override) => {
    const copyValue = override || value
    if (canRender && copyValue) {
      e.preventDefault();
      e.target.blur(); // Remove focus to prevent selection
      navigator.clipboard.writeText(copyValue);
      clearTimeout(timeoutRef.current);
      setShowTooltip(true);
      timeoutRef.current = setTimeout(() => setShowTooltip(false), 2000);
    }
  };

  const inputProps = (canRender)
    ? {
        onClick: handleClick,
        sx: { cursor: "pointer" },
        title: "Click to copy",
      }
    : {};
    
  const tooltipProps = {
    title: showTooltip ? "Copied!" : "Click to copy",
    open: showTooltip ?? undefined,
    placement: "bottom-start",
    PopperProps: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -16],
          },
        },
      ],
    }
  };

  return { inputProps, tooltipProps, shouldWrap: readOnly };
};
